
import './blank.scss'
import { isMobile } from '@/utils/util';
import { useEffect } from 'react';
import { LayoutDesktop } from '../LayoutPC/LayoutDesktop';


function BlankPage() {

    useEffect(() => {

        const timer = setInterval(() => {
            window.location.hash = '#/'
        }, 100)

        return () => {
            clearInterval(timer)
        };

    }, [])


    return (
        <>
            {
                isMobile() ? (<div className='blank'></div>) : (
                    <LayoutDesktop>
                        <div className='pc-blank'></div>
                    </LayoutDesktop>
                )
            }
        </>

    );
}

export default BlankPage;
